import React from 'react';
import styled from 'styled-components';
import { Card, Typography } from '@material-ui/core';

import CardContent from '../common/card/CardContent';

const StyledCard = styled(Card)`
  .card-content {
    padding: 32px;
    text-align: center;
  }
  .title {
    margin-bottom: 24px;
  }
  .description {
    padding-top: 24px;
  }
  .image {
    overflow: hidden;
    margin-bottom: 8px;
    img {
      width: 65%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

const OnboardingThankYou: React.FC = () => {
  return (
    <StyledCard>
      <CardContent className='card-content'>
        <div className='image'>
          <img
            alt='Thank You'
            draggable='false'
            src='/assets/onboarding/thank-you.png'
          />
        </div>
        <Typography variant='h2' className='title'>
          Thank You
        </Typography>
        <Typography variant='body1' className='description'>
          We're setting up your trial environment and one of our customer
          success team members will be in touch to schedule a time for your
          Sierra QMS walkthrough.
        </Typography>
        <Typography variant='body1' className='description'>
          If you have any questions regarding the QMS setup, please contact{' '}
          <a href='mailto:support@sierralabs.com'>support@sierralabs.com</a>
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default OnboardingThankYou;
